import { render } from "./changePassword.vue?vue&type=template&id=16cc1cbc"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"
script.render = render

export default script